<template>
  <div>
    <Filters v-model="filterParams" :catalogs="catalogs" :loading="loading" />
    <div
      style="height: 50vh"
      v-if="!!filterParams.warehouse && loading"
      class="md-layout md-gutter"
      :class="`md-alignment-center-center`"
    >
      <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div v-else-if="!!filterParams.warehouse && quotations.length === 0 && !loading">
      <md-empty-state md-icon="category" md-label="No hay cotizaciones"></md-empty-state>
    </div>
    <div v-else-if="!!filterParams.warehouse && !!quotations.length && !loading">
      <div v-for="(items, group) in groupedSearchData" :key="group">
        <span class="md-subheader quo-group-caption">{{ group }}</span>
        <tabs
          :options="{ useUrlFragment: false }"
          class="orders-tab"
          :key="items.map(({ id }) => id).join('-')"
        >
          <tab v-for="item in items" :key="item.id" :id="item.id" :name="tabName(item)">
            <md-card class="maxCard">
              <quotation
                v-if="item"
                :quotation="item"
                @selected="selected"
                :statusClass="statusClass"
              />

              <md-card-actions v-if="item.name !== 'Activo' && !item.totalPurchase">
                <md-button
                  class="md-success"
                  v-if="
                    !toResponseFile(item.responseFile) &&
                    !disabledRejected(item.status)
                  "
                  @click="uploadfileQuotation(item)"
                >Subir archivo</md-button>
                <span
                  class="text-success spanStyle"
                  v-if="toResponseFile(item.responseFile)"
                  @click="downloadQuotation(item.responseFile)"
                >VER ARCHIVO</span>
                <md-button
                  v-if="
                    (!disabledAutorized(item.status) &&
                      !disabledRejected(item.status)) ||
                    needsAuth(item.status)
                  "
                  :class="needsAuth(item.status) ? 'geca-button' : 'md-primary'"
                  :disabled="
                    validateAuth(item.responseFile, needsAuth(item.status))
                  "
                  @click="authorizeQuotation(item, needsAuth(item.status))"
                >{{ needsAuth(item.status) ? "Autorizar" : "Aprobar" }}</md-button>
                <md-menu
                  v-if="disabledAutorized(item.status)"
                  md-direction="bottom-end"
                  :mdCloseOnClick="closeOnClick"
                  :mdCloseOnSelect="closeOnSelect"
                >
                  <md-button
                    md-menu-trigger
                    class="md-primary"
                    :disabled="sendingTotalPurchase"
                  >Compra</md-button>
                  <md-menu-content>
                    <md-menu-item
                      v-for="c in dataOption"
                      @click="dataOpcionClick(c.name, item)"
                      v-bind:key="c.id"
                    >{{ c.name }}</md-menu-item>
                  </md-menu-content>
                </md-menu>
                <md-button
                  v-if="!disabledRejected(item.status)"
                  :disabled="
                    !$can('delete', 'Materials_Quotation', 'materialsquotation')
                  "
                  class="md-danger"
                  @click="quotationReject(item.id)"
                >Rechazar</md-button>
              </md-card-actions>
              <!-- <md-card-actions v-else>
              </md-card-actions>-->
              <md-card-actions v-else>
                <!-- <md-button class="md-success" @click="sendMailProvider(item.id)">Enviar correo</md-button> -->
                <md-button class="md-success" @click="sendTotalPurchase(item)">Confirmar</md-button>
                <md-button class="md-danger" @click="CancelarPurchase(item)">Cancelar</md-button>
              </md-card-actions>
            </md-card>
          </tab>
        </tabs>
      </div>
    </div>
    <uploadFile
      :showDialog="showDialog"
      @closeDialog="closeDialog"
      @uploadFilePDf="uploadFilePDf"
      :ObjQuotation="ObjQuotation"
    />
    <dialogPurchase
      @close="close"
      :showPurchase="showPurchase"
      :dataPurchase="dataPurchase"
      @send="sendConfirmPurchase"
      :itemQuotation="itemQuotation"
      :sendingPurchase="sendingTotalPurchase"
    />
  </div>
</template>
<script>
// *** COMPONENTS
import quotation from "./quotations";
import uploadFile from "./uploadFileModal";
import warehouseRouteMixin from "./../warehouseRouteMixin";
import dialogPurchase from "./dialogSendPurchase";
import Filters from "./Filters";

// *** SERVICES
import quotationService from "@/services/purchase/quotation";
import warehouseService from "@/services/purchase/warehouse";

// *** UTILS
import mapPermissions from "@/plugins/accountPermissions/mapPermissions";
import { debounce } from "lodash";
import moment from "moment";

const quotationHeaderIconFilter = (status) => {
  if (status.name === "Rechazado") {
    return "cancel";
  } else if (status.name === "Aprobado") {
    return "check_circle";
  } else if (status.name === "Correo enviado") {
    return "email";
  } else if (status.name === "Activo") {
    return "unsubscribe";
  }
};
const colorIcons = (status) => {
  if (status.name === "Rechazado") {
    return "md-accent text-danger";
  } else if (status.name === "Aprobado") {
    return "text-success";
  } else if (status.name === "Correo enviado") {
    return "text-info";
  } else if (status.name === "Activo") {
    return "text-warning";
  }
};
export default {
  name: "QuotationsTrackingIndex",
  components: {
    quotation,
    uploadFile,
    dialogPurchase,
    Filters,
  },
  mixins: [warehouseRouteMixin],
  data() {
    return {
      catalogs: {
        warehouses: [],
        status: [],
      },
      filterParams: {
        warehouse: null,
        search: null,
        status: 0,
        dateFrom: moment("2024-01-01").format("YYYY-MM-DD"),
        // dateFrom: moment().subtract(3, "months").format("YYYY-MM-DD"),
        dateTo: moment().format("YYYY-MM-DD"),
      },
      loading: false,
      quotations: [],

      sendingTotalPurchase: false,
      showDialog: false,
      ObjQuotation: {},
      dataOption: [
        {
          id: 0,
          name: "Compra total",
        },
        {
          id: 1,
          name: "Compra parcialmente",
        },
      ],
      closeOnClick: false,
      closeOnSelect: true,
      selectedElements: [],
      showPurchase: false,
      isSelected: "",
      available: true,
      searchStatus: null,
      disabledFolio: false,
      disabledStatus: false,

      dataPurchase: {
        sendConditions: null,
        expectedDelivery: null,
        doesVATApply: false,
      },
      itemQuotation: null,
    };
  },
  methods: {
    // *** FETCHING METHODS

    fetchQuotations() {
      this.loading = true;
      quotationService
        .searchQuotation(this.filterParams)
        .then(
          (response) =>
            (this.quotations = response.filter(
              ({ materials }) => !!materials.length
            ))
        )
        .catch(this.$fireErrorResponse)
        .finally(() => {
          this.loading = false;
          this.sendingTotalPurchase = false;
        });
    },
    validateAuth(file, needsAuth) {
      if (needsAuth) {
        return (
          !this.toResponseFile(file) &&
          !this.canCanValidateMaterialEntriesPurchaserequisition
        );
      } else {
        return !this.toResponseFile(file);
      }
    },

    authorizeQuotation(item, needsAuth) {
      let payload = {
        quotation: item.folio,
      };
      quotationService
        .quotationApprove(payload, needsAuth)
        .then(() => {
          this.fetchQuotations(this.filterParams.warehouse);
          this.$successMessage({ title: "Cotización autorizada" });
        })
        .catch(this.$fireErrorResponse);
    },
    uploadfileQuotation(item) {
      const index = this.quotations.indexOf(item);
      if (this.checkAllPrices(item.materials)) {
        this.quotations[index].validateField = false;
        this.showDialog = true;
        this.ObjQuotation = item;
      } else {
        this.quotations[index].validateField = true;
      }
    },
    CancelarPurchase(item) {
      this.changeStatus(item, false);
    },
    changeStatus(item, isType) {
      const index = this.quotations.indexOf(item);
      const auxConcept = this.quotations[index];
      const newConcept = { ...auxConcept, totalPurchase: isType };
      this.quotations.splice(index, 1, newConcept);
    },
    closeDialog() {
      this.showDialog = false;
    },
    uploadFilePDf(filePDF, item) {
      let payload = new FormData();
      let quotationId = item.id;
      payload.append("response_file", filePDF);
      let payloadData = {
        // quotation: item.id,
        supplies: [],
      };
      for (let i = 0; i < item.materials.length; i++) {
        let aux = {};
        aux.supply = item.materials[i].id;
        aux.price = item.materials[i].unitPrice;
        payloadData.supplies.push(aux);
      }
      this.uploadFileQuotation(payload, quotationId).then(() =>
        this.updateSuppliesQuotation(payloadData, quotationId)
      );
    },
    uploadFileQuotation(payload, quotationId) {
      this.loading = true;
      return quotationService
        .uploadFileQuotation(payload, quotationId)
        .then(() => this.fetchQuotations())
        .catch(this.$fireErrorResponse)
        .finally(() => (this.loading = false));
    },
    updateSuppliesQuotation(payload, quotationId) {
      this.loading = true;
      quotationService
        .updateSuppliesQuotation(payload, quotationId)
        .then(() => {
          this.fetchQuotations();
          this.$successMessage({
            text: "Precios actualizados y archivo cargado",
          });
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.loading = false));
    },
    checkAllPrices(materials) {
      let flag = true;
      for (let item of materials) {
        if (item.unitPrice == "0.000000" || item.unitPrice === "") {
          flag = false;
        }
      }
      return flag;
    },
    downloadQuotation(urlPdf) {
      const win = window.open(urlPdf, "_blank");
      win.focus();
    },
    downloadWithVueResource(url, nameFile) {
      this.$http({
        method: "get",
        url: url,
        responseType: "arraybuffer",
      }).then((response) => {
        this.forceFileDownload(response, nameFile);
      });
    },
    forceFileDownload(response, nameFile) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile);
      document.body.appendChild(link);
      link.click();
    },
    needsAuth({ name }) {
      return name === "Sin Autorización";
    },
    disabledAutorized({ name }) {
      return name === "Aprobado";
    },
    disabledRejected({ name }) {
      return name === "Rechazado";
    },
    toResponseFile(file) {
      return !!file;
    },
    dataOpcionClick(c, item) {
      setTimeout(() => {
        if (c === "Compra parcialmente") {
          this.changeStatus(item, true);
        } else {
          this.sendTotalPurchase(item, true);
        }
      }, 300);
    },
    selected(elements) {
      this.selectedElements = elements;
    },
    sendTotalPurchase(item, sendTotal) {
      this.showPurchase = true;
      this.itemQuotation = item;
      if (sendTotal) {
        this.selectedElements = item.materials.map(({ id }) => id);
      }
    },
    close() {
      this.dataPurchase = {};
      this.showPurchase = false;
      this.selectedElements = [];
    },
    sendConfirmPurchase(dataPurchase, itemQuotation) {
      this.sendingTotalPurchase = true;
      const { materials } = itemQuotation;
      const totalPrice = (materials) => {
        let total = 0;
        materials.forEach((d) => {
          total += parseFloat(d.unitPrice);
        });
        return total;
      };
      const isTotalPriceGreaterThan = totalPrice(materials) >= 250000;
      let payload = {
        quotation: itemQuotation.id,
        send_conditions: dataPurchase.sendConditions,
        expected_delivery_days: dataPurchase.expectedDelivery,
        does_VAT_apply: dataPurchase.doesVATApply,
        selected_supplies: this.selectedElements,
      };
      return quotationService
        .toPurchaseOrden(payload)
        .then((response) => {
          const responseMsg = isTotalPriceGreaterThan
            ? response.data.Warning
            : response.data.folio;
          this.fetchQuotations();
          this.$fire({
            icon: response.data.Warning ? "warning" : "success",
            title: "Éxito",
            text: `Orden de compra creada: ${responseMsg}`,
          });
        })
        .catch((err) => {
          this.sendingTotalPurchase = false;
          this.$fireErrorResponse(err);
        })
        .finally(() => {
          this.changeStatus(itemQuotation, false);
          this.showPurchase = false;
          this.dataPurchase = {};
        });
    },
    quotationReject(id) {
      this.$confirmMessage(
        {
          title: `¿Seguro que deseas rechazar?`,
          text: "La cotización sera rechazada",
        },
        () => {
          let payload = {
            quotation: id,
          };
          return quotationService
            .quotationReject(payload)
            .then(() => {
              this.fetchQuotations(this.filterParams.warehouse);
              this.$successMessage({ title: "Cotización rechazada" });
            })
            .catch(this.$fireErrorResponse);
        }
      );
    },
    sendMailProvider(id) {
      this.$confirmMessage(
        {
          title: `¿Quieres enviar correo?`,
          text: "El correo se enviara al proveedor",
        },
        () => {
          let payload = {
            quotation: id,
          };
          return quotationService
            .sendEmailProvider(payload)
            .then(() => {
              this.fetchQuotations();
              this.$successMessage({ title: "Correo enviado" });
            })
            .catch(this.$fireErrorResponse);
        }
      );
    },

    statusClass({ status: { name }, providerStatus }) {
      switch (name) {
        case "Activo":
          return "";
        case "Correo enviado":
          return providerStatus.name !== "Consolidado"
            ? "newProvider"
            : "sendMail";
        default:
          break;
      }
    },
    tabName(quotation) {
      const icon = quotationHeaderIconFilter(quotation.status);
      const color = colorIcons(quotation.status);
      const past = `<i class="md-icon md-icon-font md-theme-default ${color}">${icon}</i>`;
      const quotaionClassed = `<span class="${color}"> ${quotation.folio} ${quotation.providerName}  </span>`;
      return `${past} ${quotaionClassed}`;
    },
  },
  watch: {
    filterParams: {
      immediate: true,
      deep: true,
      handler({ warehouse }) {
        if (warehouse) {
          this.fetchQuotations();
        }
      },
    },

    "filterParams.search": debounce(function () {
      this.fetchQuotations();
    }, 500),
  },
  computed: {
    ...mapPermissions("PurchaseRequisition", "purchaserequisition", [
      "can_validate_material_entries",
    ]),
    groupedSearchData() {
      const { quotations: quotes } = this;
      const byGroupingSheet = {};
      quotes.forEach((quo) => {
        const { groupingSheet } = quo;
        let group = byGroupingSheet[groupingSheet];
        if (!group) {
          group = [];
          byGroupingSheet[groupingSheet] = group;
        }
        group.push(quo);
      });

      return byGroupingSheet;
    },
  },
  mounted() {
    Promise.all([
      warehouseService.fetchiWarehouse(),
      quotationService.fetchStatus(),
    ])
      .then(([warehouses, status]) => {
        this.catalogs.warehouses = warehouses;
        this.catalogs.status = status.filter(({ name }) =>
          ["Aprobado", "Activo", "Correo enviado", "Rechazado"].includes(name)
        );
      })
      .catch(this.$fireErrorResponse)
      .finally(() => (this.loading = false));
  },
};
</script>
<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

.md-card.active {
  background: md-get-palette-color(red, 100);
}
.md-card.sendMail {
  background: md-get-palette-color(green, 100);
}
.md-card.newProvider {
  background: md-get-palette-color(yellow, 100);
}
.geca-button {
  background-color: #ff9800 !important;
}
.spanStyle {
  padding: 10px;
  font-weight: bolder;
  cursor: pointer;
}
.spanStyle:hover {
  background-image: linear-gradient(to bottom, #e6ffe9, #e6ffe9);
}
.spanStyle:active {
  margin-left: 1px 1px 0;
  box-shadow: -1px -1px 1px #000;
  outline: 1px solid green;
  -moz-outline-radius: 5px;
  background-image: linear-gradient(to top, #d5e3d7, #d5e3d7);
}
.md-card.maxCard {
  height: 50%;
  margin: 0;
}
.quo-group-caption {
  float: right;
}

.md-card,
.md-card-content,
.md-card-actions {
  border: none !important;
  box-shadow: none;
  margin: 0 !important;
}

.orders-tab {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/QuotesTracking/index.vue